// extracted by mini-css-extract-plugin
module.exports = {"button":"DirectMessageButton_button__1F4TK","loading":"DirectMessageButton_loading__2_LmS","icon":"DirectMessageButton_icon__bZyCY"};